<template>
  <div class="p-2 sticky top-14 z-10">
    <div @click="emitAction" class="flex items-center p-2 text-center text-white rounded-md font-bold text-md"
         :class="classDynamic"
         :style="`background:linear-gradient(90deg, ${darkerColor} 0%, ${lighterColor} 100%)`">
      <div v-if="actions" class="desktop:hidden w-4"/>
      <div class="flex mobile:flex-col"><span>{{ title }}</span>&nbsp; <span>{{ description }}</span></div>
      <Icon v-if="actions" :icon="icon" class="fill-secondary-100 p-1 rotate-90"/>
    </div>
  </div>
</template>

<script>
import Icon from "@/design/Icon.vue";
import {computed} from "vue";

export default {
  name: "Strip",
  components: {Icon},
  props: {
    actions: {type: Boolean},
    colorBg: {type: String},
    title: {type: String},
    description: {type: String},
    icon: {type: String, defaults: 'arrow-up'},
  },
  setup(props, {emit}) {
    const classDynamic = computed(() => {
      const classActions = props.actions ? 'justify-between cursor-pointer' : 'justify-center'
      return [classActions]
    })


    const lighterColor = computed(() => lighten(props.colorBg, 5))
    const darkerColor = computed(() => darken(props.colorBg, 20))

    const lighten = (color, percentage) => {
      const amount = Math.round(2.55 * percentage);
      const [r, g, b] = color.match(/\w\w/g).map((hex) => parseInt(hex, 16)); // Hex a RGB
      return `rgb(${Math.min(255, r + amount)}, ${Math.min(255, g + amount)}, ${Math.min(
        255,
        b + amount
      )})`;
    }

    const darken = (color, percentage) => {
      const amount = Math.round(2.55 * percentage);
      const [r, g, b] = color.match(/\w\w/g).map((hex) => parseInt(hex, 16));
      return `rgb(${Math.max(0, r - amount)}, ${Math.max(0, g - amount)}, ${Math.max(
        0,
        b - amount
      )})`;
    }

    const emitAction = () => {
      if (props.actions) {
        emit('click')
      }
    }
    return {props, emit, classDynamic, lighterColor, darkerColor, lighten, darken, emitAction}
  }
}

</script>

<style scoped lang="scss">

</style>
